import styled from 'styled-components';
import { ImageUtils } from '../../utils/ImageUtils';
import { NumberPad } from './NumberPad';
import { useState } from 'react';
import { UsedTicketModal } from './UsedTicketModal';
import { useApiHook } from '../../hook/useApiHook';
import { MODAL_TYPE, modalStore } from '../../store/modalStore';

export const TicketWithUsedButton = ({
  ticketNumber,
  isUsed,
}: {
  ticketNumber: number;
  isUsed: string;
}) => {
  const [visiblePad, setVisiblePad] = useState(false);
  const [usedTicket, setUsedTicket] = useState(false);
  const [password, setPassword] = useState<string>('');
  const { ticketUse, getEventInfo } = useApiHook();
  const { showModal } = modalStore();
  const [tempUsed, setTempUsed] = useState(isUsed);

  return (
    <>
      <Container>
        {tempUsed === 'Y' ? <UsedDim $backImag={ImageUtils.UsedStamp} /> : <></>}
        <Ticket src={ImageUtils.CardMainWithUse}></Ticket>
        <TicketTextContainer>
          <Inner>
            <Title>오프라인 이벤트 참가 정보</Title>
            <NumberTitleContainer>
              <NumberTitle>참가자 번호</NumberTitle>
            </NumberTitleContainer>
            <TicketText>{ticketNumber}</TicketText>

            <UseButton
              onClick={() => {
                setPassword('');
                setVisiblePad(true);
              }}
            ></UseButton>
          </Inner>
        </TicketTextContainer>
      </Container>

      <NumberPad
        password={password}
        setPassword={setPassword}
        visiblePad={visiblePad}
        close={() => {
          setPassword('');
          setVisiblePad(false);
        }}
        showUsedTicket={() => setUsedTicket(true)}
      />

      <UsedTicketModal
        isVisibleCommon={usedTicket}
        commonCallback1={async () => {
          try {
            await ticketUse(ticketNumber);
            await getEventInfo();
            setUsedTicket(false);
            showModal({
              modalType: MODAL_TYPE.USED_TICKET,
            });
            setTempUsed('Y');
          } catch (e) {
            console.log(e);
          }
        }}
        commonCallback2={() => {
          setUsedTicket(false);
        }}
      />
    </>
  );
};

const UseButton = styled.button`
  position: absolute;
  width: 80px;
  height: 160px;
  right: 0;
  top: 0;
`;

const Ticket = styled.img`
  position: relative;

  width: 330px;
`;

const Title = styled.h3`
  font-weight: 800;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.02em;

  color: rgba(0, 0, 0, 0.6);

  font-size: 15px;
  line-height: 24px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Inner = styled.div`
  width: 200px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.2);
  margin-left: 40px;

  margin-right: 12px;
`;

const NumberTitleContainer = styled.div`
  margin: 0 auto;

  background: rgba(0, 0, 0, 0.1);
  border-top: 1px solid #000000;

  height: 29px;
`;

const NumberTitle = styled.h4`
  font-weight: 800;
  text-align: center;
  letter-spacing: -0.02em;
  color: #000000;

  font-size: 16px;
  line-height: 29px;
`;

const Container = styled.div`
  position: relative;
  overflow-x: hidden;
`;

const UsedDim = styled.div<{ $backImag: string }>`
  position: absolute;
  width: 100%;
  height: calc(100% - 3px);
  background: rgba(0, 0, 0, 0.5);
  z-index: 2;
  border-radius: 15px;
  background-image: url(${(props) => props.$backImag});
  background-repeat: no-repeat;
`;

const TicketTextContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
`;

const TicketText = styled.p`
  font-weight: bold;
  font-weight: 700;
  color: #000000;
  text-align: center;

  font-size: 64px;
  line-height: 69px;
`;
